import { render, staticRenderFns } from "./contact-selector.vue?vue&type=template&id=4defeba5"
import script from "./contact-selector.vue?vue&type=script&lang=js"
export * from "./contact-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports